<template>
  <div v-if="showMode" class="pointTransInfoView onePictureDialog dy3dDialog">
    <div class="headerClass">
      <div class="headerTitle">
        <span>坐标定位</span>
      </div>

      <div class="boxClose">
        <img
          :src="require('@/assets/images/poscloseIcon.png')"
          style="cursor: pointer"
          @click="close()"
        />
      </div>

      <!-- <span @click="close()">
              <img :src="require('@/assets/images/poscloseIcon.png')" style="cursor: pointer;"/> -->
      <!-- <a-icon type="close" style="color: aliceblue;cursor: pointer;" /> -->
      <!-- </span> -->
    </div>
    <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')" />
    <div class="contentClass">
      <!-- radio 按钮 -->
      <!-- <div @click="close()" style="text-align: right"><a-icon type="close" style="color: aliceblue" /></div> -->
      <!-- <div>
        <span>范围：</span>
        <a-radio-group
          v-model="rdoType"
          :options="rdoTypeOptions"
          @change="rdoTypeChange"
        ></a-radio-group>
      </div> -->

      <!--十进制 经纬度坐标 高程 表单 -->
      <form id="decimalSystemForm" class="form-horizontal" autocomplete="off">
        <a-row class="viewTen" style="display:block">
          <a-col :span="11">
            <a-col :span="7"><span>范围：</span></a-col>
            <a-col :span="17" style="display:flex">
              <a-radio-group
                v-model="rdoType"
                :options="rdoTypeOptions"
                @change="rdoTypeChange"
              ></a-radio-group>
            </a-col>
          </a-col>
          <a-col :span="11" style="height:38px"></a-col>
          <a-col
            :span="11"
            title="请输入-180至180之间的数字"
            style="margin-right: 8%"
          >
            <a-col :span="7"><label>经度：</label></a-col>
            <a-col :span="17"><a-input v-model="center.lng"></a-input></a-col>
          </a-col>
          <a-col :span="11" title="请输入-90至90之间的数字">
            <a-col :span="7"><label>纬度：</label></a-col>
            <a-col :span="17"><a-input v-model="center.lat"></a-input></a-col>
          </a-col>
          <a-col :span="11" class="altClass">
            <a-col :span="7"><label>高程：</label></a-col>
            <a-col :span="17"><a-input v-model="center.alt"></a-input></a-col>
          </a-col>
        </a-row>
      </form>
    </div>
    <!-- "坐标定位" button按钮 -->
    <div style="text-align: center">
      <a-row style="margin-top: 20px">
        <a-col :span="12" class="btnClass">
          <a-button class="toolBtn btn btn-primary" @click="bindMourseClick"
            >图上拾取</a-button
          >
          <a-button class="toolBtn btn btn-primary" @click="submitCenter"
            >坐标定位</a-button
          >
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointTrans",
  data() {
    return {
      showMode: false,
      pointEntity: null,
      rdoType: "sjz",
      center: {
        lat: 31.814176,
        lng: 117.225362,
        alt: 5105.3,
        heading: 359.2,
        pitch: -83.1,
      },
      rdoTypeOptions: [
        { label: "十进制", value: "sjz" },
        // { label: '度分秒', value: 'dfm' },
        // { label: '平面坐标', value: 'pmzb' },
      ],
    };
  },
  methods: {
    rdoTypeChange(e) {
      console.log("rdoTypeChange", e, this.rdoType);
    },
    close() {
      this.showMode = false;
      if (this.pointEntity) {
        this.map.graphicLayer.removeGraphic(this.pointEntity);
      }
    },
    setMap(map) {
      this.map = map;
      this.showMode = true;
      console.log("设置map", this.map);
    },
    bindMourseClick() {
      //设置鼠标抓紧为true
      let that = this;
      this.map.setCursor(true);
      this.map.once(mars3d.EventType.click, function (event) {
        that.map.setCursor(false);
        //获得迪卡坐标系
        let cartesian = event.cartesian;
        console.log("cartesian", cartesian);
        let point = mars3d.LngLatPoint.fromCartesian(cartesian);
        point.format(); //经度、纬度、高度
        that.center.lat = point.lat;
        that.center.lng = point.lng;
        that.center.alt = point.alt;
        that.updateMarker(false);
      });
    },
    submitCenter() {
      if (this.center.lng > 180 || this.center.lng < -180) {
        this.$message.error("请输入有效的经度值");
        return;
      }
      if (this.center.lat > 90 || this.center.lat < -90) {
        this.$message.error("请输入有效的纬度值");
        return;
      }

      this.updateMarker(true); //更新点
    },
    updateMarker(hasCenter) {
      let position = [this.center.lng, this.center.lat, this.center.alt];
      if (this.pointEntity == null) {
        this.pointEntity = new mars3d.graphic.PointEntity({
          position: position,
          style: {
            color: "#3388ff",
            pixelSize: 10,
            outlineColor: "#ffffff",
            outlineWidth: 2,
          },
        });
        this.map.graphicLayer.addGraphic(this.pointEntity);
      } else {
        this.pointEntity.position = position;
      }

      if (hasCenter) {
        this.pointEntity.flyTo({ radius: 1000 });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.btn-primary {
  background-color: rgba(15, 97, 255, 0.5);
  color: #fff;
  border: 0px solid #fff;
}
/**infoview浮动面板*/
.pointTransInfoView {
  z-index: 10;
  position: absolute;
  // top: 40px;
  top: 7%;
  right: 0.5%;
  width: 500px;
  max-width: 500px;
  height: 270px;
  // right: 10px;
  border-radius: 4px;
  color: #ffffff;
  -webkit-box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
  box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
  backdrop-filter: blur(15px);
  //   z-index: 19870101;
  .headerClass {
    position: relative;
  }
  .contentClass {
    .form-horizontal {
      margin-top: 3%;
    }
    .altClass {
      /deep/.ant-col {
        margin: 3% 0;
      }
    }
  }
  .btnClass {
    width: 44%;
    display: flex;
    justify-content: space-around;
  }
}
.infoview-left {
  right: auto;
  left: 10px;
}

.pointTransInfoView input,
.pointTransInfoView select,
.pointTransInfoView textarea {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 14px;
}

/deep/.ant-radio-inner {
  background-color: transparent;
  border-color: #ffffff;
}

//单选框里面的小圆圈
/deep/.ant-radio-inner::after {
  background-color: #0e5fff;
}
</style>